import { putNoBody } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { IDeactivateApiKeyDialogProps } from "./DeactivateApiKeyDialog";

export function useDeactivateApiKeyDialog(props: IDeactivateApiKeyDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();

    const deactivateMutation = useDotLegalMutation(deactivate, {
        onSuccess: async (response: Result<string>) => {
            if (!response.success()) {
                props.onCloseDialog();
                snackbar.show(translateString("apiKeyDeactivateFailed"), "warning");
                return;
            }

            snackbar.show(translateString("apiKeyDeactivated"));
            await props.onDeactivated();
        },
    });

    function deactivate() {
        return putNoBody<string>(`/api-keys/${props.id}/deactivate`);
    }

    return {
        deactivateApiKey: () => deactivateMutation.mutateAsync(),
        inProgress: deactivateMutation.isLoading,
    };
}
